import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { AddinsurancetypepopupComponent } from '../../generalpopup/addinsurancetypepopup/addinsurancetypepopup.component';
import { AddinsurancecompanypopupComponent } from '../../generalpopup/addinsurancecompanypopup/addinsurancecompanypopup.component';
@Component({
  selector: 'app-addinsurancepopup',
  templateUrl: './addinsurancepopup.component.html',
  styleUrls: ['./addinsurancepopup.component.css']
})
export class AddinsurancepopupComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "insurance";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  insuranceColl: any = [];
  insuranceBO: any = {};

  empColl: any = [];
  insurancetypeColl: any = [];
  insurancecompanyColl: any = [];
  insurancedetailsColl: any = [];


  insuranceform = new FormGroup({
    insuranceid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    startdt: new FormControl(null, Validators.required),
    enddt: new FormControl(null, Validators.required),
    insurancetypeid: new FormControl(null, Validators.required),
    insurancecompanyid: new FormControl(null, Validators.required),
    amount: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });

  @Input() insuranceid: number = 0;
  
  @Input() empid: number = 0;

  @Output() emitData = new EventEmitter();

  dateCustomClasses: DatepickerDateCustomClasses[];


  constructor(private appService: AppdataService, public loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal, private datePipe: DatePipe, private productFindService: NgbModal) {

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }



  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.insuranceform.reset();
      this.fnInitializeFormGroup();
      if (this.insuranceid > 0) {
        this.fngetInsurance();
      }
     // this.fngetEmp();
      this.fngetInsuranceType();
      this.fngetInsuranceCompany();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.insuranceid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }
  fnInitializeFormGroup() {
    this.insuranceform.setValue({
      insuranceid: 0,
      empid: this.empid,
      startdt: new Date(),
      enddt: new Date(),
      insurancetypeid: null,
      insurancecompanyid: null,
      amount: null,
      descr: '',
      inactive: false
    })
  }
  fnSetEmployee() {
  this.insuranceform.patchValue({empid:this.empid})
}

  fngetEmp() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            console.log(this.empColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetInsuranceType() {
    var data = {
      'insurancetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getInsuranceType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.insurancetypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetInsuranceCompany() {
    var data = {
      'insurancecompanyid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getInsuranceCompany(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.insurancecompanyColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetInsurance() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'insuranceid': this.insuranceid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getInsurance(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            console.log(res.json().result)

            this.insuranceColl = res.json().result
            var editdata = this.insuranceColl[0];

            this.fnEditMode(editdata);
            this.insuranceBO = editdata;

           //this.insurancedetailsColl = res.json().result[1];
         
            
          }
          else {

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {


          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      // if (this.loginService.fnCheckFornControlNotfound(this.insuranceform.get('enddt'))) {
      //   this.insuranceform.controls['enddt'].setErrors(null);
      // }

      //Validate
      if (this.insuranceform.valid) {

        // if (this.insuranceform.get('enddt').value) {
        //   if (this.loginService.fnCheckFornControlNotfound(this.insuranceform.get('enddt').value), this.insuranceform.get('startdt')) {
        //     this.insuranceform.controls['enddt'].setErrors({ 'notfound': true })
          
        //   }  
        // }
        //Check
        this.saveloading = true;

        var data = {
          'startdt': this.fnFormatDatetime(this.insuranceform.get('startdt').value),
          'enddt': this.fnFormatDatetime(this.insuranceform.get('enddt').value),
          'insuranceid': this.insuranceid,
          'empid': this.insuranceform.get('empid').value,
          'insurancetypeid': this.insuranceform.get('insurancetypeid').value,
          'insurancecompanyid': this.insuranceform.get('insurancecompanyid').value,
          'amount': this.insuranceform.get('amount').value,
          'descr': this.insuranceform.get('descr').value,
          'inactive': this.insuranceform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckInsurance(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {

                if (this.insuranceform.get('insuranceid').value > 0) {
                  //Update 
                  this.fnSetInsurance(data);
                }
                else {
                this.fnInsertInsurance(data);
                }
              }
              else {
                  if (_checkresult === "name") {
                    this.saveloading = false;

                    this.insuranceform.controls['insurancename'].setErrors({ 'notfound': true });
                  
                  }
                }
              }
              else {
                this.saveloading = false;

                this.loginService.fnAPIError(res.json())
              }
            },
            (err) => {
              this.saveloading = false;

              this.toastr.error('Error', err);
            });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertInsurance(data) {

    this.appService.fnInsertInsurance(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {


            console.log(res.json())
            this.toastr.success('', "The new insurance has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.paymode);
            var result = res.json().result;

            var insuranceid = 0;
            if (result.length > 0) {
              insuranceid = result[0].insuranceid
            }
            this.emitData.emit(insuranceid);
            this.activeModal.close(true);

            this.fngetInsurance();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        }
        (err) => {
          this.saveloading = false;
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }
  //Set
  fnSetInsurance(data) {

    this.appService.fnSetInsurance(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The Insurance has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.insuranceid, data.empname);

            this.decline();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  private fnEditMode(deptBO) {

    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));
    deptBO.enddt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.enddt));

    this.insuranceform.setValue({
      insuranceid: deptBO.insuranceid,
      empid: deptBO.empid,
      insurancetypeid: deptBO.insurancetypeid,
      insurancecompanyid: deptBO.insurancecompanyid,
      descr: deptBO.descr,
      amount: deptBO.amount,
      startdt: deptBO.startdt,
      enddt: deptBO.enddt,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

   
  
  }

  //AddInsuranceType

  private fnAddInsuranceType() {

    const modalRef = this.productFindService.open(AddinsurancetypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetInsuranceType();

      if (receivedEntry > 0) {
        this.insuranceform.patchValue({ insurancetypeid: receivedEntry })
      }
    });

  }


  private fnAddInsuranceCompany() {

    const modalRef = this.productFindService.open(AddinsurancecompanypopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetInsuranceCompany();

      if (receivedEntry > 0) {
        this.insuranceform.patchValue({ insurancecompanyid: receivedEntry })
      }
    });

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}

